package pl.michal_cyran.brand_hub.subpages.dayMathAd.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaChartColumn
import com.varabyte.kobweb.silk.components.icons.fa.FaChartLine
import com.varabyte.kobweb.silk.components.icons.fa.FaDivide
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.components.widgets.staggerDelay
import pl.michal_cyran.brand_hub.subpages.dayMathAd.composables.ExerciseCard
import pl.michal_cyran.brand_hub.subpages.dayMathAd.composables.FeaturedExerciseCard
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun DayMathMoreExercises() {
    ColorMode.current.toSitePalette()

    Column {

        VisibilityAware(modifier = Modifier) { isVisible ->
            Column {
                H6(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 0)
                        .toAttrs()
                ) {
                    Text("Szeroki zakres materiału")
                }

                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    Text("Jeszcze więcej ćwiczeń")
                }
            }
        }

        VisibilityAware(modifier = Modifier) { isVisible ->
            SimpleGrid(
                numColumns(base = 1, md = 4),
                modifier = Modifier.gap(1.5.cssRem)
            ) {
                val exercises = listOf(
                    Triple("Statystyka", @Composable{ FaChartColumn() }, "Odczytywanie danych statystycznych z wykresów i tabel."),
                    Triple("Funkcja liniowa", @Composable{ FaChartLine() }, "Parametry funkcji liniowej i ich wpływ na wykres."),
                    Triple("Podstawy", @Composable{ FaDivide() }, "Tabliczka mnożenia, zamiana jednostek, mnożenie i dzielenie przez potęgi 10.")
                )

                exercises.forEachIndexed { index, (title, icon, subtitle) ->
                    ExerciseCard(
                        title = title,
                        icon = icon,
                        subtitle = subtitle,
                        modifier = Modifier
                            .revealFadeSlideUpScale(
                                isVisible,
                                delayMs = staggerDelay(index, step = 120),
                                distance = 20.px,
                                fromScale = 0.94
                            )
                    )
                }

                FeaturedExerciseCard(
                    title = "I wiele innych",
                    subtitle = "Baza ćwiczeń jest stale rozwijana.",
                    modifier = Modifier
                        .revealFadeSlideUpScale(
                            isVisible,
                            delayMs = staggerDelay(3, step = 120),
                            distance = 20.px,
                            fromScale = 0.94
                        )
                )
            }
        }
    }
}